import styles from './Waiting.module.css';

export function Waiting() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.icon}>⏳</div>
        <h2 className={styles.title}>Account Pending</h2>
        <p className={styles.message}>
          Your account has been created successfully. An administrator will review and assign your
          role shortly.
        </p>
        <p className={styles.submessage}>
          You'll be able to access the platform once your account has been activated.
        </p>
      </div>
    </div>
  );
}
